/**
 * 不设置过期时间，有效期到关闭浏览器（关闭所有标签），也就是说关闭浏览器cookie自动清除
 * @param cname
 * @param cvalue
 * @param exdays：init  有效天数，0表示不设置有效期
 */
export function setCookie (cname, cvalue, exdays) {
  if (Number(exdays) > 0) {
    let d = new Date()
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000))
    let expires = 'expires=' + d.toGMTString()
    document.cookie = cname + '=' + cvalue + '; ' + expires + ';' + 'path=/'
  } else {
    document.cookie = cname + '=' + cvalue + ';' + 'path=/'
  }
}

export function getCookie (cname) {
  let name = cname + '='
  let ca = document.cookie.split(';')
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim()
    if (c.indexOf(name) === 0) { return c.substring(name.length, c.length) }
  }
  // console.log('getCookie123', cname, ca)
  return ''
}

export function clearCookie (cname) {
  setCookie(cname, '', 0)
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js